// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"de490871","392":"085669e8","562":"ada0ba5e","675":"2dbf4117","848":"b3dbcb41","880":"5134f14b","937":"e521719c"}[chunkId] + ".chunk.css";
};